var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62793 12.793C8.62793 13.3593 8.73945 13.9201 8.9562 14.4433C9.17292 14.9665 9.49058 15.4419 9.89104 15.8424C10.2915 16.2428 10.7669 16.5604 11.2901 16.7772C11.8133 16.9939 12.3741 17.1055 12.9404 17.1055C13.5068 17.1055 14.0675 16.9939 14.5907 16.7772C15.114 16.5604 15.5894 16.2428 15.9898 15.8424C16.3903 15.4419 16.7079 14.9665 16.9247 14.4433C17.1414 13.9201 17.2529 13.3593 17.2529 12.793C17.2529 12.2266 17.1414 11.6658 16.9247 11.1426C16.7079 10.6194 16.3903 10.144 15.9898 9.74354C15.5894 9.34312 15.114 9.02546 14.5907 8.80871C14.0675 8.59199 13.5068 8.48047 12.9404 8.48047C12.3741 8.48047 11.8133 8.59199 11.2901 8.80871C10.7669 9.02546 10.2915 9.34312 9.89104 9.74354C9.49058 10.144 9.17292 10.6194 8.9562 11.1426C8.73945 11.6658 8.62793 12.2266 8.62793 12.793Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64062 6.05273V7.13588C4.64062 7.76761 4.89158 8.37346 5.33828 8.82016C5.78498 9.26686 6.39082 9.51785 7.02255 9.51785C7.65431 9.51785 8.26016 9.26686 8.70686 8.82016C9.15356 8.37346 9.40451 7.76761 9.40451 7.13588V6.05273",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11C6.21197 11 5.43169 11.1552 4.70362 11.4567C3.97562 11.7583 3.31413 12.2003 2.75695 12.7574C2.19976 13.3146 1.75785 13.9761 1.45638 14.704C1.15492 15.4319 0.999836 16.2121 1 17",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40451 3.8457V6.05224L6.95861 6.84072L4.64062 6.05224V3.89314",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1175 2.82869L6.959 0.894531L1.7998 2.82869L6.959 4.76358L12.1175 2.82869Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7998 2.82812V5.40773",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8252 5.42578L0.74707 7.58203H2.90332L1.8252 5.42578Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 14.7969V12.2813C13.0781 12.1859 13.0402 12.0945 12.9729 12.0271C12.9055 11.9598 12.814 11.9219 12.7188 11.9219H12",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7969H14.1562",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 10.4844C12.4398 10.4844 12.3594 10.404 12.3594 10.3047C12.3594 10.2054 12.4398 10.125 12.5391 10.125",
    stroke: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 10.4844C12.6383 10.4844 12.7188 10.404 12.7188 10.3047C12.7188 10.2054 12.6383 10.125 12.5391 10.125",
    stroke: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_5060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentInfo);
export default __webpack_public_path__ + "static/media/student_info.de060c7e07092525baeb26a7279f985e.svg";
export { ForwardRef as ReactComponent };